export default "__VITE_ASSET__BBYeW9f___"